import styled from "styled-components";

export const ControlsContainer = styled.div`
  display: flex;
  
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--very-dark-blue);
  border: 1px solid var(--white);
  position: absolute;
  bottom: 0;

  .buttons {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
    .velocityButton {
      border-style:dashed;
      background-color: var(--very-dark-blue);
      padding: 0.5rem;
      border-radius: 100%;
    }
    .repeatButton {
      background-color: var(--very-dark-blue);
      padding: 0.5rem;
      border-radius: 100%;
    }
    .playPauseButton {
      background-color: var(--very-dark-blue);
      padding: 0.5rem;
      border-radius: 100%;
      }
    
    .tooltip {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #000000;
     box-shadow: 0 0 6px rgba(255,255,255,0.6);
    color: white;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 2px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
    z-index: 10;
  }

  .tooltip.visible {
    opacity: 1;
  }
  /* progresso */
  .progressWrapper {
    flex: 1;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .progressBar {
    position: relative;
    height: 8px;
    width: 100%;
    background: rgba(255,255,255,0.08);
    border-radius: 999px;
    
  }

  .progressFill {
    height: 100%;
    width: 0%;
    background: white;
    transition: width 120ms linear;
  }
  .progressDot {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background: white;
  box-shadow: 0 0 6px rgba(255,255,255,0.6);
  transition: left 120ms linear;
  z-index: 2;
  
}
  


  @media (max-width: 768px) {
  background-color: var(--very-dark-blue);
  border: 1px solid var(--white);
  height: 4rem;

    .velocityButton {
    border-style:dashed;
    background-color: var(--very-dark-blue);
    padding: 0.5rem;
    border-radius: 100%;
    
    }
    .repeatButton {
      background-color: var(--very-dark-blue);
      padding: 0.5rem;
      border-radius: 100%;
    }
    
    .tooltip {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #222;
    color: white;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 2px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
    z-index: 10;
  }

  .tooltip.visible {
    opacity: 1;
  }
}
`;
